// Influencer Applications page component for InfluenceHub MVP
// Shows a clean list of recently applied-to campaigns for influencers
// No stat cards, no filters, just a focused list

import React from 'react';
import { useAuth } from '../../context/AuthContext.jsx';
import Navbar from '../../components/layout/Navbar';
import Sidebar from '../../components/layout/Sidebar';
import MyApplicationsList from './MyApplicationsList';

const InfluencerApplications = ({ onNavigate }) => {
  const { user, profile } = useAuth();

  // Redirect if not an influencer
  if (profile && profile.userType !== 'influencer') {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar onNavigate={onNavigate} />
        <div className="flex">
          <Sidebar onNavigate={onNavigate} />
          <main className="flex-1 p-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center py-12">
                <p className="text-gray-600">This page is only available for influencers.</p>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar onNavigate={onNavigate} />
      <div className="flex">
        <Sidebar onNavigate={onNavigate} />
        <main className="flex-1 p-6">
          <div className="max-w-7xl mx-auto">
            {/* Page header */}
            <div className="mb-6">
              <h1 className="text-2xl font-bold text-gray-900">My Applications</h1>
              <p className="text-sm text-gray-500 mt-1">Recently applied campaigns</p>
            </div>

            {/* Applications list */}
            <MyApplicationsList />
          </div>
        </main>
      </div>
    </div>
  );
};

export default InfluencerApplications;

